export const MOODS_DATA = {
  msFluent: [
    {
      src: '/icons/ms-fluent/terrible.png',
      label: 'Terrible',
      id: 'terrible',
      score: 0,
    },
    {
      src: '/icons/ms-fluent/bad.png',
      label: 'Bad',
      id: 'bad',
      score: 2,
    },
    {
      src: '/icons/ms-fluent/okay.png',
      label: 'Okay',
      id: 'okay',
      score: 4,
    },
    {
      src: '/icons/ms-fluent/fine.png',
      label: 'Fine',
      id: 'fine',
      score: 6,
    },
    {
      src: '/icons/ms-fluent/happy.png',
      label: 'Happy',
      id: 'happy',
      score: 8,
    },
    {
      src: '/icons/ms-fluent/amazing.png',
      label: 'Amazing',
      id: 'amazing',
      score: 10,
    },
  ],
};
